import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import tracking from 'dibs-tracking';

import styles from './styles/CartToolbar.scss';

function getReturnLink(firstItemCategoryPath) {
    const refererMyPage = document.referrer.indexOf('1stdibs.com/my/') >= 0;
    const referer1stdibs = document.referrer.indexOf('1stdibs.com') >= 0;
    let returnLink = referer1stdibs ? document.referrer : '/';

    if (refererMyPage) {
        returnLink = firstItemCategoryPath ? `/${firstItemCategoryPath}/` : '/';
    }

    return returnLink;
}

const CartToolbar = ({ totalResults, firstItemCategoryPath }) => {
    return (
        <div className={styles.container}>
            <div className={styles.title}>
                <FormattedMessage id="CartToolbar.header" defaultMessage="My Cart" />
                {totalResults > 0 && (
                    <span data-tn="cart-toolbar-total-results" className={styles.count}>
                        (<FormattedNumber value={totalResults} />)
                    </span>
                )}
            </div>
            <a
                className={styles.return}
                href={getReturnLink(firstItemCategoryPath)}
                onClick={() => {
                    tracking.trackEvent({
                        category: 'cart actions',
                        action: 'back to shopping click',
                    });
                }}
                data-tn="toolbar-return-link"
            >
                <span data-tn="toolbar-return-copy">
                    <FormattedMessage id="CartToolbar.return" defaultMessage="Back to Shopping" />
                </span>
            </a>
        </div>
    );
};

CartToolbar.propTypes = {
    totalResults: PropTypes.number,
    firstItemCategoryPath: PropTypes.string,
};

export default CartToolbar;
